<button
  sdButton
  [theme]="buttonTypes.Secondary"
  fullWidth="true"
  class="text-b3-s-500"
  (click)="scrollToProductRecommendations()"
>
  смотреть похожие
</button>
